import { render } from "./BrandsFilter.vue?vue&type=template&id=5b2435b1"
import script from "./BrandsFilter.vue?vue&type=script&lang=js"
export * from "./BrandsFilter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__